const DOUBLE_GIS_DOMAIN = '2gis.com';

export function isDoubleGisWhiteLabel(domain: string): boolean {
    return domain.includes(DOUBLE_GIS_DOMAIN);
}
